import { render, staticRenderFns } from "./FinancialChannelStatistics.vue?vue&type=template&id=73e26446&"
import script from "./FinancialChannelStatistics.vue?vue&type=script&lang=ts&"
export * from "./FinancialChannelStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FinancialChannelStatistics.vue"
export default component.exports